module.exports = __webpack_public_path__ + "img/logo.2229fb6c.png";